import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

const setupUrl = `${environment.apiBaseUrl}platform/setupCompleted`;


@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  constructor(private http: HttpClient) { }

  isSetupCompleted(): Observable<{ complete: boolean }> {
    return this.http.get<{ complete: boolean }>(`${setupUrl}`);
  }
}
